import _ from 'lodash';

/**
 * Redux Middleware for Azure AD authentication
 * This middleware will authenticate using @ey/ad library which internally uses adal.js
 * On successful authentication the token is added to the action and passed to the next middleware
 * On Error an error object is added to the action and passed to the next middleware
 */
const updateOfflineTasks = (config) => (store) => (next) => (action) => {
	if (action.type != 'GET_BOOKMARK_TASKS') {
		return next(action);
	}

	//Check for config availability
	if (!config) {
		const configMsg = `
        Config unavailable.
        The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}

	if (!action.meta) {
		action.meta = {};
	}

	next({
		type: 'SET_OFFLINE_PREP',
		isCompleted: false
	});

	action.type = 'SET_TASK_BOOKMARK';
	action.meta.tasks = action.response;
	action.meta.type = 'OFFLINE_PREP';
	return next(action);
};

export default updateOfflineTasks;
